import { ADMIN_ENDPOINT } from '@Env/variables';
import {
  Creds,
  InitializeAcc,
  OpenAICredDisplay,
  PromptVersionControl,
} from '@Models/types';
import { createAxiosInstance } from './axios';

export const accountsAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, ADMIN_ENDPOINT);

  return {
    getAuthorizedUsers: async (): Promise<InitializeAcc> => {
      const res = await axios.get('/accounts/initializeAcc');
      return res.data;
    },

    validateTestRail: async (
      testrail_username: string,
      testrail_api_key: string
    ) => {
      const { data } = await axios.post<boolean>('/accounts/validateTestRail', {
        testrail_username,
        testrail_api_key,
      });
      if (!data) throw new Error('Unauthorized/Invalid Key');
      return data;
    },

    //new jira functions
    validateJira: async (email: string, token: string) => {
      const { data } = await axios.post<boolean>('/accounts/validateJira', {
        email,
        token,
      });
      if (!data) throw new Error('Unauthorized/Invalid Jira Credentials');
      return data;
    },

    updateJira: async (email: string, token: string) => {
      const { data } = await axios.post('/accounts/updateJira', {
        email,
        token,
      });
      return data;
    },

    newAccountCredentials: async (input: Creds) => {
      const { data } = await axios.post('/accounts/insertNewCred', input);
      return data;
    },

    updateApiKeys: async (input: Creds) => {
      const { data } = await axios.post('/accounts/updateDefCred', input);
      return data;
    },

    updateUserPrompt: async (input: OpenAICredDisplay) => {
      const { data } = await axios.post('/accounts/updateUserPrompt', input);
      return data;
    },

    updateOpenAICreds: async (input: OpenAICredDisplay) => {
      const { data } = await axios.post('/accounts/updateAdminCred', input);
      return data;
    },

    getCurrentGlobalPrompt: async () => {
      const { data } = await axios.post<PromptVersionControl>(
        '/accounts/getCurrentGlobalPrompt'
      );
      return data;
    },

    getAllUserPrompts: async () => {
      const { data } = await axios.get('/accounts/getAllUserPrompts');
      return data === 'No User Prompts Yet!' ? [] : data;
    },

    getAllPrompts: async () => {
      const { data } = await axios.get('/accounts/getAllPrompts');
      return data === 'No Prompts Yet!' ? [] : data;
    },

    getAllUsers: async () => {
      const { data } = await axios.get<string[]>('/accounts/getAllUsers');
      return data;
    },

    deleteUser: async (userEmail: string) => {
      await axios.post('/accounts/deleteUser', { user: userEmail });
    },

    deletePrompt: async (version: PromptVersionControl) => {
      await axios.delete('/accounts/deletePrompt', { data: version });
    },

    addPrompt: async (
      email: string,
      prompt: string,
      version: string,
      created_by: { name: string; email: string },
      is_personal: boolean,
      nickname?: string
    ) => {
      const { data } = await axios.post<PromptVersionControl>(
        '/accounts/addPrompt',
        {
          email,
          prompt,
          version,
          created_by,
          is_personal,
          nickname,
        }
      );
      return data;
    },

    addUser: async (userEmail: string) => {
      await axios
        .post('/accounts/addUser', {
          user: userEmail,
        })
        .then((data) => {
          return data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 409) {
              throw new Error('User already exists!');
            }
          }
        });
    },

    updateTestrail: async (username: string, apiKey: string) => {
      const { data } = await axios.post('/accounts/updateTestrail', {
        username,
        apiKey,
      });
      return data;
    },
  };
};
